<template>

  <div class="height-100">
    <Unavailable
      v-if="unavailable"
      title="Fluxo de aprovação"
      class="height-100" />
    <div
      v-if="!unavailable"
      class="vflex">
      
      <!---
      <div class="vflex-row-0 pt-3">
        <ul class="nav nav-tabs">
          <li class="nav-item ml-3">
            <a class="nav-link" :class="{active: modelType === 'requisition'}" href="javascript:void(0)" @click="changeModelType('requisition')">{{ $t('Requisition') }}</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{active: modelType === 'job'}"
              href="javascript:void(0)"
              @click="changeModelType('job')">{{ $t('Job') }}</a>
          </li>
        </ul>
      </div>
      -->

      <div
        class="vflex-row-0 vflex-header p-3">
        <div class="page-title">
          <div class="title">
            <h4>{{ $t('Requisition approval flow') }}</h4>
          </div>
          <div class="btn-row">
            <div class="form-inline">
              <select-company 
                  class="mr-2"
                  style="min-width: 220px"
                  :placeholder="$t('Company')"
                  :value="filters.company_id"
                  @input="setCompany">
                  </select-company>
              <select-departament 
                  class="mr-2"
                  style="min-width: 220px"
                  :placeholder="$t('Department')"
                  :value="filters.departament_id"
                  @input="setDepartament">
                  </select-departament>
              <button
                type="button"
                class="btn btn-primary"
                @click="showCreateModal ()">
                + {{ $t('New flow') }}
                </button>
            </div>
          </div>
        </div>
      </div>

      <div class="vflex-row-1 auto-scroll">
        <Paginaty
          :total="paginate.total"
          :pages="paginate.pages"
          :page="paginate.page"
          :creating="creating"
          :loading="loading"
          @changePage="loadData">
          
          <template slot="content">
            <table class="table">
              <thead>
                <tr>
                  <th-sort
                    field="company_id"
                    :value="sort"
                    @input="setSort">{{ $t('Company') }}</th-sort>
                  <th-sort
                    field="departament_id"
                    :value="sort"
                    @input="setSort">{{ $t('Department') }}</th-sort>
                  <th class="text-truncate">{{ $t('Groups') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(item, index) in approvalrules"
                  :key="index">
                  <td class="text-truncate"><a href="javascript:void(0)" @click="showEditModal (item)">{{ item.company_id ? item.company_id.name : $t('All companies') }}</a></td>
                  <td class="text-truncate"><a href="javascript:void(0)" @click="showEditModal (item)">{{ item.departament_id ? item.departament_id.name : $t('All departments') }}</a></td>
                  <td class="text-truncate">{{ item.groups ? item.groups.length : 0 }}</td>
                </tr>
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>
        </Paginaty>
        <approvalrule-form 
          v-if="modal_select"
          :initApprovalrule="modal_select" 
          @hideModal="hideModal()" 
          @deleted="loadData(); hideModal()" 
          @saved="loadData(paginate.page); hideModal()">
          </approvalrule-form>
      </div>

    </div>
  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import ApprovalruleForm from './ApprovalruleForm'
import Paginaty from '@/components/Paginaty/Paginaty'

import SelectCompany from '@/components/Fields/SelectCompany'
import SelectDepartament from '@/components/Fields/SelectDepartament'
import Unavailable from '../Unavailable/Unavailable'

export default {
  name: 'Approvalrule',
  components: {
    ApprovalruleForm,
    ThSort,
    InputKeyword,
    Paginaty,

    SelectCompany,
    SelectDepartament,
    Unavailable
  },
  data () {
    return {
      unavailable: false,
      creating: true,
      loading: true,
      modal_select: false,
      filters: {},
      sort: 'name',
      modelType: 'requisition'
    }
  },
  computed: {
    approvalrules () {
      return this.$store.getters.getApprovalrules
    },
    paginate () {
      return this.$store.getters.getApprovalrulesPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      this.filters['model_type'] = this.modelType

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectApprovalrules', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      }).catch(err => {
        this.unavailable = err.response && err.response.data && err.response.data.name === 'UpgradeRequired'
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {model_type: this.modelType}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    filters
    */
    setCompany (value) {
      this.filters.company_id = value
      this.loadData(1)
    },
    setDepartament (value) {
      this.filters.departament_id = value
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    changeModelType (type) {
      this.creating = true
      this.modelType = type
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Approvalrule/Approvalrule.vue